"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileToBook = void 0;
const spreadsheet_1 = require("common/spreadsheet");
const parseFile_1 = require("@/utils/parseFile");
const papaparse_1 = require("papaparse");
const fileToBook = (rawFile) => __awaiter(void 0, void 0, void 0, function* () {
    if (rawFile &&
        rawFile.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        return (0, spreadsheet_1.openXLSXBook)(yield (0, parseFile_1.readExcel)(rawFile));
    }
    else if (rawFile && rawFile.type === "text/csv") {
        const text = yield (rawFile === null || rawFile === void 0 ? void 0 : rawFile.text());
        return (0, spreadsheet_1.openCSVBook)((0, papaparse_1.parse)(text, {
            delimiter: ",",
            quoteChar: '"',
            skipEmptyLines: "greedy",
        }).data);
    }
    else {
        throw new Error("Invalid file type");
    }
});
exports.fileToBook = fileToBook;
